export default {
  labels: {
    open: 'Mostra articoli',
    collapse: 'Chiudi articoli',
    in_stock: 'Disponibile',
    out_of_stock: 'Non disponibile',
    visible: 'Visibile nel menu',
    hidden: 'Nascosto dal menu',
  },
  list: {
    name: 'Voce del menu',
    price: 'Prezzo',
    is_available: 'DISPONIBILE/NON DISPONIBILE',
  },
};
